<div class="modal-backdrop"></div>
<div class="modal" [ngStyle]="{'width': width,'height': height}">

  <div class="modal-header" *ngIf="title !== ''">
    <div class="modal-sub-header">
      <img *ngIf="iconUrl" [src]="iconUrl || 'assets/icons/add_user_modal_icon.svg'" alt="modal_icon">
      <div class="modal_title">{{ title }}</div>
    </div>
    <div class="modal-actions">
      <app-svg-icon
        class="close-btn"
        (click)="onClose()"
        [path]="'assets/icons/close_icon.svg'"
      ></app-svg-icon>
    </div>
  </div>
  <div class="modal-body" [ngStyle]="{ 'overflow-y': scrollable ? 'auto' : 'hidden' }">
    <ng-template #modalContent></ng-template>
  </div>
    @if (showActionBtns) {
        <div class="divider"></div>
        <div class="action_btns">
            <button class="secondary_button" (click)="onClose()">{{ secondaryActionBtnText }}</button>
            <button *ngIf="!hidePrimaryButton" class="primary_button"
                    (click)="handlePrimaryBtnClick()">{{ primaryActionBtnText }}
            </button>
        </div>
    }
</div>
